<div class="headerblock bg-gray-100 pl-4 row">
	<div *ngIf="show_logo" class="aviablock col">
		<img class="avialogo img-fluid pointer d-md-none" [routerLink]="''" [src]="'/assets/header-avia-connect-logo.svg'">
		<img class="avialogo img-fluid pointer d-none d-md-block" [routerLink]="''" [src]="'/assets/header-avia-connect-logo.svg'">
	</div>
	<ng-content></ng-content>
</div>
